import React from 'react';
import clsx from 'clsx';
import styles from './logo-lemana-pro.module.css';
import { LemanaProLogoVerticalRu, LemanaProLogoMiniIcon, LemanaProLogoHorizontalIcon, LemanaProLogoIconLine, LemanaProLogoDefault, LemanaProLogoVerticalEn } from './icons';
/**
 * `<LogoLemanaPro/>` - Компонент лого Лемана Про
 *
 * @example```tsx
 * <LogoLemanaPro variant="monochrome" invert onlyLogo />`
 * ```
 */
const getWrapperClassName = (styleClasses, variant, invert, logoSize, onlyLogo, className) => clsx(styleClasses.logoLemanaPro, styleClasses[variant], className, {
  [styleClasses.invert]: invert,
  [styleClasses.mini]: logoSize === 'mini',
  [styleClasses.onlyLogo]: onlyLogo
});
const getIcon = (type, locale) => {
  switch (type) {
    case 'Horizontal':
      return LemanaProLogoHorizontalIcon;
    case 'Line':
      return LemanaProLogoIconLine;
    case 'Vertical':
    default:
      return locale === 'ru' ? LemanaProLogoVerticalRu : LemanaProLogoVerticalEn;
  }
};
export const LogoLemanaPro = ({
  variant = 'default',
  invert = false,
  locale = 'ru',
  onlyLogo = false,
  logoSize = 'default',
  className,
  'data-testid': testId = 'logoLemanaPro',
  type = 'Vertical',
  ...rest
}) => {
  const wrapperClassName = getWrapperClassName(styles, variant, invert, logoSize, onlyLogo, className);
  const renderLogo = () => {
    if (logoSize === 'mini') {
      return /*#__PURE__*/React.createElement(LemanaProLogoMiniIcon, null);
    }
    if (onlyLogo) {
      return /*#__PURE__*/React.createElement(LemanaProLogoDefault, null);
    }
    const LogoIcon = getIcon(type, locale);
    return /*#__PURE__*/React.createElement(LogoIcon, null);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    role: "presentation",
    "data-testid": testId,
    ...rest
  }, renderLogo());
};